import { CAST_MESSAGES } from '../../config/receiver';
import { bootstrapAction } from '../extensions';
import { PluginInterface } from './PluginInterface';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';

type ConsoleMethods = 'log' | 'error' | 'warn';

export class LogProxyPlugin implements PluginInterface {
  init() {
    bootstrapAction.register(this.bootstrap.bind(this));
  }

  async bootstrap(context: CastReceiverContext) {
    window.console = new Proxy(console, {
      get(target, prop: ConsoleMethods) {
        switch (prop) {
          case 'log':
          case 'error':
            return (...args: any[]) => {
              context.sendCustomMessage(CAST_MESSAGES.CONSOLE, undefined, [prop, args]);
              return target[prop](...args);
            };

          default:
            return target[prop];
        }
      },
    });
  }
}
